import type { DocumentSummary } from "~/api/types";
import type {
  DocumentEditableField,
  ReleaseEditableField,
  UpdateDocumentData,
} from "~/api/v2/requests";
import type { EditableField } from "./libraryTypes";

export const isReleaseEditableField = (
  field: EditableField,
): field is ReleaseEditableField =>
  field === "reviewFrom" || field === "reviewTo" || field === "adoptedAt";

export const isEditableField = (
  document: DocumentSummary,
  field: EditableField | undefined,
): boolean => {
  if (field === undefined) return false;

  if (document.archivedAt !== null) {
    return false;
  }

  if (field === "adoptedAt") {
    return false;
  }

  if (field === "reviewFrom") {
    return !document.latestRelease.artifact.isWorkflowOngoing;
  }

  return true;
};

const payloadKeysByEditableField: Record<
  DocumentEditableField,
  (keyof UpdateDocumentData)[]
> = {
  categoryId: ["categoryId"],
  tierId: ["tierId", "linkedDocumentIds"],
  referenceNumber: ["referenceNumber"],
  ownerId: ["ownerId"],
  publisherId: ["publisherId"],
  tags: ["tagIds"],
  links: ["linkedDocumentIds"],
};

export const getPayloadForField = (
  field: DocumentEditableField,
  payload: UpdateDocumentData,
): UpdateDocumentData =>
  Object.fromEntries(
    Object.entries(payload).filter(([key]) =>
      payloadKeysByEditableField[field].includes(
        key as keyof UpdateDocumentData,
      ),
    ),
  );
